import {useTranslation} from 'react-i18next';
import {useHistory, useParams} from 'react-router-dom';
import {useAuth} from './useAuth';
import {useUserFullName, useCase, useCaseUpsertMutation} from './useApi';
import {useEffect} from 'react';
import {AppScreen} from './AppScreen';
import {Logo} from './Logo';
import {Headline} from './Headline';
import {CaseForm} from './CaseForm';

export const UnrequestCaseScreen = (props) => {
  const {t} = useTranslation();
  const history = useHistory();
  const params = useParams();
  const userId = useAuth().userId;
  const userFullName = useUserFullName(userId);
  const caseId = props.caseId || params.caseId;
  const caseValues = useCase(caseId);
  const mutation = useCaseUpsertMutation(caseId);

  useEffect(() => {
    if (mutation.isSuccess) {
      props.onClose();
    }
  }, [mutation.isSuccess]);

  const submit = (formValues) => {
    props.onClose();
  };

  const cancel = () => {
    mutation.mutate({
      ...caseValues,
      CollaborationStatus: '',
      id_Instructor_Collaborator: '',
      PT_PrescribingPhysician: '',
    });
  };

  return (
    <div className="UnrequestCaseScreen">
      <Headline>{t('UnrequestCaseScreen.headline')}</Headline>
      <CaseForm i18nScopes={['UnrequestCaseScreen']} values={caseValues} onSubmit={submit} onCancel={cancel} mutation={mutation}/>
    </div>
  );
};

export default UnrequestCaseScreen;
